import { ModelBase } from 'store/model-base';

export class OneTimePayment extends ModelBase {
    public static storeName: string = 'oneTimePayment';

    public isUsingNewCard: boolean;
    public isUsingSameAddress: boolean;
    public userData: OneTimePaymentNewCardInfo;
    public ccType: string;
    public ccLastFour: string;
    public amount: number;
    public isUsingSameAmount: boolean;
}
